export const APP_ROOT_ID = "root";

export const PAGE_BANNER_ID = "page-banner";
export const PAGE_HEADER_ID = "page-header";
export const PAGE_LAYOUT_ID = "page-layout";
export const PAGE_CONTENT_ID = "page-content";
export const PAGE_NAVIGATION_ID = "page-navigation";
